import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "cookie-banner" }
const _hoisted_2 = { class: "cookie-banner__header" }
const _hoisted_3 = { class: "cookie-banner__icon" }
const _hoisted_4 = {
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_5 = ["fill"]
const _hoisted_6 = { class: "cookie-banner__title" }
const _hoisted_7 = { class: "cookie-banner__body" }
const _hoisted_8 = { class: "cookie-banner__desc" }
const _hoisted_9 = { class: "cookie-banner__bottom" }
const _hoisted_10 = { class: "cookie-banner__actions" }

import { useRouter } from 'vue-router'
import { useThemeColor } from '@/utils/theme'


export default /*@__PURE__*/_defineComponent({
  __name: 'CookieBanner',
  props: {
    isUpdate: { type: Boolean },
    presentationUrl: {}
  },
  emits: ["accept"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "v6a4b44f4": (_unref(themeColor))
}))

const props = __props

const emit = __emit

const router = useRouter()
const themeColor = useThemeColor()

function onAccept(type: 'necessary' | 'all') {
  emit('accept', type)
}

function goToCookieDetail() {
  router.push('/cookieSettings')
}

function goToPrivacyPolicy() {
  if (props.presentationUrl) {
    window.location.href = props.presentationUrl
  } else {
    router.push({ path: 'PrivacyPolicy' })
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock("svg", _hoisted_4, [
          _createElementVNode("path", {
            d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z",
            fill: _unref(themeColor)
          }, null, 8, _hoisted_5)
        ]))
      ]),
      _createElementVNode("span", _hoisted_6, _toDisplayString(__props.isUpdate ? _ctx.$t('Cookies更新') : _ctx.$t('Cookies')), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("span", _hoisted_8, [
        _createTextVNode(_toDisplayString(__props.isUpdate ? _ctx.$t('Cookie使用规则已更新,用于登录状态留存、体验优化与数据统计,详情见') : _ctx.$t('本站通过Cookie留存登录信息、提升使用体验及统计服务数据，具体使用规则可查阅')) + " ", 1),
        _createElementVNode("span", {
          class: "cookie-banner__link",
          onClick: goToPrivacyPolicy
        }, _toDisplayString(_ctx.$t('Cookie协议政策')), 1),
        _cache[2] || (_cache[2] = _createTextVNode("。 ", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", {
        class: "cookie-banner__link-setting",
        onClick: goToCookieDetail
      }, _toDisplayString(_ctx.$t('Cookie 设置')), 1),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", {
          class: "cookie-banner__btn cookie-banner__btn--outline",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (onAccept('necessary')))
        }, _toDisplayString(_ctx.$t('仅接受必要')), 1),
        _createElementVNode("div", {
          class: "cookie-banner__btn cookie-banner__btn--fill",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (onAccept('all')))
        }, _toDisplayString(_ctx.$t('接受全部')), 1)
      ])
    ])
  ]))
}
}

})